export default __webpack_public_path__ + "images/liveVideo.2ae33f22d02d6ff4e9054da79c26dc59.svg";